<mat-card appearance="outlined" *appRoles="['Personas.Listar']">
  <mat-card-header>
     <div class="header-nombre-nuevo">
      <h2>Personas</h2>
      <app-button-new *appRoles="['Personas.Crear']"
        (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {} })"></app-button-new>
    </div>
  </mat-card-header>
  <mat-card-content>

    <form [formGroup]="formFilter">
      <div class="row">
        <!-- Tipo Documento -->
        <div class="col">
          <mat-form-field class="w-100" appearance="outline">
            <ngx-spinner [zIndex]="-1" name="spBusquedaTipoDoc" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label matTooltip="Tipo de documento">Tipo Documento</mat-label>
            <mat-select placeholder="Seleccione opción" formControlName="IdTipoDocumento">
              <mat-option [value]="tipoDocumento.id" *ngFor="let tipoDocumento of lstTiposDocumento">
                {{ tipoDocumento.descripcion | uppercase }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Número Documento -->
        <div class="col">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label matTooltip="Número de documento">Nro. Documento</mat-label>
            <input matInput type="text" maxlength="150" formControlName="NroDocumento" />
          </mat-form-field>
        </div>

        <!-- Nombre -->
        <div class="col">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Nombre</mat-label>
            <input matInput type="text" maxlength="150" formControlName="Nombre" />
          </mat-form-field>
        </div>

        <!-- Apellido -->
        <div class="col">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Apellido</mat-label>
            <input matInput type="text" maxlength="150" formControlName="Apellido" />
          </mat-form-field>
        </div>

        <!-- Correo -->
        <div class="col">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Correo</mat-label>
            <input matInput type="text" maxlength="150" formControlName="Correo" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-checkbox formControlName="Activo" aria-label="Activo">
            Activo
          </mat-checkbox>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-auto">
          <div style="display: flex; align-items: center; gap: 8px;">
            <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
            <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
          </div>
        </div>
        <div class="col-auto">

          <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
            Filtros Avanzados
          </mat-slide-toggle>
        </div>
      </div>
    </form>
  </mat-card-content>
  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <div *ngIf="data">

      <!-- Tabla de Datos -->
      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort matSortStart="asc">
        <ng-container matColumnDef="nombreCompleto">
          <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Nombre Completo</strong></mat-header-cell>
          <mat-cell *matCellDef="let persona">{{
            persona.nombreCompleto | titlecase
            }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="documento">
          <mat-header-cell *matHeaderCellDef mat-sort-header><strong>Documento</strong></mat-header-cell>
          <mat-cell *matCellDef="let persona">{{ persona.tipoDocumento }} - {{ persona.nroDocumento }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="correo">
          <mat-header-cell *matHeaderCellDef><strong>Correo</strong></mat-header-cell>
          <mat-cell *matCellDef="let persona">{{ persona.correo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="estados">
          <mat-header-cell *matHeaderCellDef><strong>Estados</strong></mat-header-cell>
          <mat-cell *matCellDef="let persona">
            <mat-icon matTooltip="Esta activo" class="icon-hover" *ngIf="persona.activo">toggle_on</mat-icon>

            <mat-icon class="icon-hover" matTooltip="No esta activo" *ngIf="!persona.activo">toggle_off</mat-icon>

            <mat-icon class="icon-hover" matTooltip="Sin correo, deberia asignar uno." *ngIf="persona.correo"
              (click)="abrirDialogoCorreo(persona)">
              mail
            </mat-icon>
            <!-- <app-status-badge [estado]=" persona.activo "></app-status-badge> -->
          </mat-cell>
        </ng-container>

      <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let item" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
               <button mat-menu-item  [routerLink]="['/personas/',item.id]"      *appRoles="['Personas.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Vista Detallada</span>
              </button>

              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {item} })"
                *appRoles="['Personas.Ver']">
                <mat-icon>visibility</mat-icon>
                <span>Vista Simple</span>
              </button>
              <button mat-menu-item
                (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {item} })"
                *appRoles="['Personas.Modificar']">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item
                (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {item} })"
                *appRoles="['Personas.Eliminar']">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>
    </div>

    <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>

    <!-- Paginación -->
    <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
      [pageSizeOptions]="[5, 10, 20, 50, 100, 200]"></mat-paginator>
  </mat-card-content>
</mat-card>
